<template>
<!-- 编辑网站公告 -->
	<el-dialog
		:visible="visibleInside"
		width="400px"
		:title="data ? '编辑消息' : '新建消息'"
		@close="$emit('close')"
		:close-on-click-modal="false"
	>
		<el-form :model="formData" label-width="100px" :rules="rules" ref="messageAddForm">
			<el-form-item prop="content" label="消息内容：">
				<el-input type="textarea" placeholder="请输入消息内容" :rows="3" v-model="formData.content"></el-input>
			</el-form-item>
			<el-form-item prop="type" label="消息类型：">
				<el-select v-model="formData.type" size="small">
					<!-- <el-option :value="1" label="交易消息"></el-option> -->
					<el-option :value="1" label="系统消息"></el-option>
					<!-- <el-option :value="3" label="咨询消息"></el-option>
					<el-option :value="4" label="首页滚动公告"></el-option> -->
				</el-select>
			</el-form-item>
			<!-- <el-form-item prop="remark" label="关联文章ID：">
				<el-input size="small" v-model="formData.remark"></el-input>
			</el-form-item> -->
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button size="small" @click="$emit('close')">取 消</el-button>
			<el-button size="small" type="primary" @click="submit" :loading="buttonLoading">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { postData, patchData } from '../../http'
export default {
	data() {
		return {
			buttonLoading: false,
			formData: {
				content: '',
				type: 1,
				remark: ''
			},
			rules: {
				content: [
					{
						required: true,
						message: '消息内容不能为空'
					}
				]
			}
		}
	},
	props: {
		visible: Boolean,
		data: Object
	},
	computed: {
		visibleInside: {
			get() {
				return this.visible
			},
			set() {}
		}
	},
	watch: {
		visible(val) {
			if (val) {
        if (this.$refs['messageAddForm']) {
          this.$refs['messageAddForm'].resetFields()
        }
			}
		},
		data(val) {
			if (val) {
				this.formData.content = val.content
				this.formData.type = val.type
				// this.formData.remark = val.remark
			}
		}
	},
	methods: {
		submit() {
			this.$refs['messageAddForm'].validate(valid => {
				if (valid) {
					this.buttonLoading = true
					if (!this.data) {
						postData('messages', { ...this.formData })
							.then(
								() => {
									this.$message.success('添加成功')
                  this.$emit('close')
                  this.$emit('refresh')
								}
							)
							.finally(() => {
								this.buttonLoading = false
							})
					} else {
						patchData(`messages/${this.data.id}`, { ...this.formData })
							.then(
								() => {
									this.$message.success('编辑成功')
                  this.$emit('close')
                  this.$emit('refresh')
								}
							)
							.finally(() => {
								this.buttonLoading = false
							})
					}
				}
			})
		}
	}
}
</script>
